import * as RadixTooltip from '@radix-ui/react-tooltip';

type Variant = 'dark' | 'light';

interface TooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  variant?: Variant;
  side?: RadixTooltip.TooltipContentProps['side'];
  align?: RadixTooltip.TooltipContentProps['align'];
  sideOffset?: number;
}

export const Tooltip = ({
  children,
  content,
  variant = 'dark',
  side = 'bottom',
  align = 'center',
  sideOffset = 8,
}: TooltipProps) => {
  const styles: Record<Variant, { arrow: string; content: string }> = {
    dark: {
      arrow: 'fill-gray-900',
      content:
        'bg-gradient-to-br from-gray-900 to-gray-800 text-white shadow-xl border border-gray-700',
    },
    light: {
      arrow: 'fill-white',
      content: 'bg-white text-gray-900 shadow-xl border border-gray-200',
    },
  };

  const style = styles[variant];

  return (
    <RadixTooltip.Provider delayDuration={200}>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            side={side}
            align={align}
            sideOffset={sideOffset}
            className={`
              TooltipContent  ${style.content} 
              rounded-lg px-3 py-2 text-xs font-medium
              max-w-xs
            `}
          >
            {content}
            <RadixTooltip.Arrow className={style.arrow} width={12} height={6} />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};
